import style from "./TableBody.module.scss";
import { dashboardQueryOptions, useGetAllCostsByTagsQuery } from "@RTKQuery/admin/dashboard/dashboard";
import { useAppSelector } from "store/hooks";
import { CostsByTag } from "@interfaces/admin/costsByTag";
import { AnalyticsStatus } from "../../../AnalyticsStatus/AnalyticsStatus";

export function TableBody({
    children
}: {
    children: (data: CostsByTag, i: number) => JSX.Element
}) {
    const { activeEndDate, activeStartDate } = useAppSelector(state => state.dashboardAdminPage);

    const { currentData: data, isError, refetch } = useGetAllCostsByTagsQuery({
        end_date: activeEndDate,
        start_date: activeStartDate
    }, dashboardQueryOptions);

    return (
        <div className={style.body}>
            {
                isError || !data ? <div style={{gridColumn: "1 / -1"}}>
                    <AnalyticsStatus error={isError}
                        message={isError ? "Не вдалося завантажити статистику витрат." : "Завантаження витрат…"}
                        retry={isError ? refetch : undefined} />
                </div> : data.filter(item => item.total_sum_usd > 0).map((row, i) => children(row, i))
            }
        </div>
    )
}
